import { LitElement } from 'lit';

class CrntElement extends LitElement {
  static {
    this.dependencies = {};
  }
  constructor() {
    super();
    Object.entries(this.constructor.dependencies).forEach(([name, component]) => {
      this.constructor.define(name, component);
    });
  }
  static define(tagName = this.tagName, elementConstructor = this, options = {}) {
    if (!tagName) {
      throw new Error(`${this.name} does not have a defined tag name.`);
    }
    const currentlyRegisteredConstructor = customElements.get(tagName);
    if (!currentlyRegisteredConstructor) {
      try {
        customElements.define(tagName, elementConstructor, options);
      } catch (_err) {
        customElements.define(tagName, class extends elementConstructor {
        }, options);
        console.error(_err);
      }
    }
  }
}

export { CrntElement };
